import { render, staticRenderFns } from "./CountdownSettings.vue?vue&type=template&id=1d93057c&scoped=true&"
import script from "./CountdownSettings.vue?vue&type=script&lang=js&"
export * from "./CountdownSettings.vue?vue&type=script&lang=js&"
import style0 from "./CountdownSettings.vue?vue&type=style&index=0&id=1d93057c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93057c",
  null
  
)

export default component.exports